import React from "react";

export default function SlopeBlue(props: any) {
  return (
    <svg className="map-slope-icon" xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100" {...props}>
      <rect x="14.4" y="14.4" width="71.19" height="71.19" fill="#009fe3"></rect>
    </svg>
  );
}